import { alpha, getOverlayAlpha } from '@mui/material/styles';

const POPOVER_ELEVATION = 8;
const SCREEN_PADDING_PX = 20;
const FOOTER_BOTTOM_PADDING_PX = 4;

export const editOptionsScreenStyles = {
  width: '480px',
  padding: `${SCREEN_PADDING_PX}px`,
};

export const backButtonStyles = {
  py: 0.5,
};

export const backButtonContentStyles = {
  display: 'flex',
  alignItems: 'center',
};

export const backButtonIconStyles = {
  marginRight: '4px',
};

export const formContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

// minmax(0, 1fr) stops a wide cell's min-content from stretching its column past the popover.
export const optionsGridStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: '12px 20px',
  alignItems: 'start',
};

export const fullWidthCellStyles = {
  gridColumn: '1 / -1',
};

export const colorPickerCellStyles = {
  alignSelf: 'center',
};

export const boldAlignedWithCheckboxViewCellStyles = {
  alignSelf: 'center',
};

export const sectionHeaderStyles = {
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  borderBottom: ({ palette }) => `1px solid ${palette.divider}`,
  pb: 0.5,
  mb: 0.5,
};

// Hosting popovers cap their height and scroll, so the actions stay pinned; the background mirrors
// the popover Paper (incl. its dark-mode elevation overlay) so options scroll underneath cleanly.
// Sticky offsets are measured inside the scroller's padding, so the footer extends through that
// padding (negative bottom + margin, matching extra padding) instead of leaving a see-through strip.
// zIndex sits above the global `form label { z-index: 99 }` (styles/index.css) but below MUI
// poppers (1300), so labels scroll under the actions while in-form (disablePortal) dropdowns
// still open over them.
export const footerStyles = {
  position: 'sticky',
  bottom: `-${SCREEN_PADDING_PX}px`,
  zIndex: 100,
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '8px',
  pt: '12px',
  pb: `${FOOTER_BOTTOM_PADDING_PX + SCREEN_PADDING_PX}px`,
  mt: '4px',
  mb: `-${SCREEN_PADDING_PX}px`,
  borderTop: ({ palette }) => `1px solid ${palette.divider}`,
  backgroundColor: 'background.paper',
  backgroundImage: ({ palette }) => {
    if (palette.mode !== 'dark') {
      return 'none';
    }

    const overlay = alpha(palette.common.white, Number(getOverlayAlpha(POPOVER_ELEVATION)));

    return `linear-gradient(${overlay}, ${overlay})`;
  },
};
